import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "swiper/css";
import "./assets/js/fontSize.min";
import "./assets/css/common.css";
createApp(App).use(store).use(router).mount('#app')
